<template>
  <div>
    <ul>
      <li v-for="item of columnData" :key="item.field">
        <span class="label">{{item.label}}</span>
        <span class="text">{{data[item.field] || "-"}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["columnData", "data"]
};
</script>

<style scoped>
ul {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 20px;
}

.label {
  display: inline-block;
  width: 40%;
  color: #4e5671;
  border: 1px solid #f3f4f5;
  padding: 15px 0px 15px 5px;
  background: #f7f8fa;
  font-weight: 600;
  height: 70px;
}
.text {
  display: inline-block;
  width: 60%;
  border: 1px solid #f3f4f5;
  padding: 15px 0px 15px 10px;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: bottom;
  height: 70px;
}
</style>